import React, { useEffect, useState } from "react";
import SimulationApi from "../../api/SimulationApi";
import { EBooleanSensorType } from "../../Model/EBooleanSensorType";
import { ModuleBooleanSensorValue, MotorDto } from "../../Model/Simulation";
import CheckBox from "../Buttons/CheckBox";
import "./SimulationMotor.css";

export default function SimulationMotor() {
  const [motors, setMotors] = useState([] as MotorDto[]);

  useEffect(() => {
    SimulationApi.getSimulatedMotors("Suite").then((motors) => {
      setMotors(motors);
    });
  }, []);

  return (
    <div className="simulation-motor-content">
      {motors.map((motor, index) => (
        <button
          key={`motor-${motor.name}`}
          id={index.toString()}

          onClick={() => SimulationApi.triggerMotorCrash(motor)}
        >{`Motor ${motor.name}: Trigger Crash`}</button>
      ))}
    </div>
  );
}
